import { DetailsRowProps, Theme } from "sprint-common-web";

export const renderNotMergableRow = (
    rowProps?: DetailsRowProps,
    render?: (ff?: DetailsRowProps) => JSX.Element | null
): JSX.Element | null => {
    if (render && rowProps)
        return render({
            ...rowProps,
            styles: { root: { backgroundColor: Theme.palette.neutralLight } }
        });

    return null;
};
